/* eslint-disable
    no-shadow,
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import _ from 'underscore';

class BenchlingCollection extends Backbone.Collection {
  // For collections that are attributes of a model
  // that might be swapped out, with listenTo(model, change:collection)
  //
  // This is a result of backbone using _.isEqual
  // to determine if the change event should fire.
  // For example:
  //     _.isEqual(new Backbone.Collection(), new Backbone.Collection()) == true
  constructor() {
    super(...arguments);
    this.cid = _.uniqueId('collection_');
  }

  // Convenience function to add attributes / models to this collection, and notably returns a promise
  // instead of the added model.
  // On success, the promise resolves to the new model.
  // On failure, the model is removed from the collection.
  betterCreate(attrsOrModel, options) {
    const model = this.add(attrsOrModel);
    const res = model.save(null, options);
    if (!res) {
      // If validation failed, remove and return.
      this.remove(model);
      return res;
    }
    return res.fail(() => this.remove(model)).then(() => model);
  }

  bulkDelete(models, options) {
    let model;
    const modelIds = (() => {
      const result = [];
      for (model of Array.from(models)) {
        if (!model.isNew()) {
          result.push(model.id);
        }
      }
      return result;
    })();
    const syncOptions = {
      contentType: 'application/json',
      dataType: 'json',
      url: this.url(),
      data: JSON.stringify({ids: modelIds}),
      ...options,
    };
    return this.sync('delete', this, syncOptions).done(() => {
      this.remove(models);
      models.forEach((model) => {
        model.trigger('destroy', model, this, options);
      });
    });
  }

  bulkUpdate(updates, options) {
    // eslint-disable-next-line no-restricted-syntax
    return this.sync('update', this, _.extend({attrs: updates}, options)).done(({updated, message}) => {
      for (const model of Array.from(updated)) {
        this.get(model.id).set(model, {parse: true});
      }
    });
  }
}

export default BenchlingCollection;
